var _g, _defs;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDefaultTransparent(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 200,
    viewBox: "0 0 200 200",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_354_1134)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M157.34 58.7037L101.497 42.538C101.056 42.3914 100.615 42.3914 100.174 42.3914C99.734 42.3914 99.4398 42.3914 98.999 42.538L42.4207 58.7037C41.0983 58.9979 40.2168 60.1737 40.2168 61.4962V139.383C40.2168 140.705 41.0984 141.881 42.4207 142.175L98.999 158.341C99.2932 158.488 99.5864 158.488 99.734 158.488H100.028H100.469C100.763 158.488 101.056 158.488 101.35 158.341L157.194 142.175C158.516 141.881 159.251 140.705 159.251 139.383L159.25 61.4962C159.398 60.1738 158.515 58.998 157.34 58.7037ZM76.6615 79.1307L63.5824 82.0696V58.7037L76.6615 55.0298V79.1307ZM153.519 137.178L103.554 151.58V49.2983L153.519 63.6997V137.178Z",
    fill: "#B7B7B7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.72 120.278H120.308L140.881 115.869C142.203 115.575 143.233 114.399 143.233 112.931L143.234 83.5393C143.234 82.0693 142.204 80.8946 140.736 80.6004L120.162 77.6616C119.281 77.515 118.399 77.8081 117.811 78.3965C117.222 78.9839 116.781 79.7179 116.781 80.6005V117.34C116.781 118.221 117.222 119.103 117.811 119.691C118.398 119.984 118.986 120.278 119.72 120.278ZM122.66 83.9802L137.356 86.0375V110.433L122.66 113.519V83.9802Z",
    fill: "#B7B7B7"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_354_1134"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 200,
    height: 200,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDefaultTransparent);
export default __webpack_public_path__ + "static/media/default-transparent.ddce4cae2182786c294422f2144c7a5c.svg";
export { ForwardRef as ReactComponent };